import React, { useEffect } from "react";

import { Form } from "@jsluna/form";

import { BLACK_BOX_ELEMENT_ID, reportError } from "@jsainsburyplc/id-ui-common";

import {
  CHALLENGE,
  USERNAME,
  PASSWORD,
  LOGIN_AFTER_REGISTRATION_FORM_ID,
  FROM_REGISTRATION,
} from "../../../constants/login";
import useCookies from "../../../hooks/useCookies";
import { getLoginLink } from "../../../utils/urls";

const isIovationEnabled = "true" === process.env.REACT_APP_IOVATION_ENABLED;

const getAndAssignBlackBoxToken = (form) => {
  try {
    const bb = window.IGLOO.getBlackbox();
    if (bb && bb.finished) {
      form.elements[BLACK_BOX_ELEMENT_ID].value = bb.blackbox;
    } else {
      reportError("Silent Login - the blackbox is not present!");
    }
  } catch (e) {
    reportError(
      `Silent Login - error occurred during getAndAssignBlackBoxToken: ${e}`
    );
  }
};

export const SilentLogin = ({ username, password, isFromRegistration }) => {
  const { loginChallenge } = useCookies();

  useEffect(() => {
    const form = document.getElementById(LOGIN_AFTER_REGISTRATION_FORM_ID);
    const submitForm = async () => {
      try {
        isIovationEnabled && (await getAndAssignBlackBoxToken(form));
        form.submit();
      } catch {
        form.submit();
      }
    };
    submitForm();
  }, []);

  return (
    <Form
      method="post"
      action={getLoginLink()}
      id={LOGIN_AFTER_REGISTRATION_FORM_ID}
    >
      {isIovationEnabled && (
        <input
          type="hidden"
          name={BLACK_BOX_ELEMENT_ID}
          id={BLACK_BOX_ELEMENT_ID}
          data-testid={BLACK_BOX_ELEMENT_ID}
        />
      )}
      <input type="hidden" name={CHALLENGE} value={loginChallenge} />
      <input type="hidden" name={USERNAME} value={username} />
      <input type="hidden" name={PASSWORD} value={password} />
      <input
        type="hidden"
        name={FROM_REGISTRATION}
        value={isFromRegistration ? "1" : "0"}
      />
    </Form>
  );
};

export default SilentLogin;
